import { Api } from "../api/Api";
import { AbandonedVehicleRun } from "../api/Application";
import { LoaderFunctionArgs } from "react-router-dom";

export async function abandonedVehicleRunListLoader( { params }: LoaderFunctionArgs ): Promise<AbandonedVehicleRun[]> {    
    const res = await Api.abandonedVehicleRunList();
    if( !res.isOk ) {
        throw new Error( "Failed to fetch image. Make sure you are logged in." );
    }
    return res.value;
}